import * as React from 'react';

const Google24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#4285F4",
    d: "M21.99 12.187c0-.82-.069-1.417-.216-2.037H12.2v3.698h5.62c-.113.92-.725 2.303-2.084 3.233l-.02.124 3.028 2.292.21.02c1.926-1.738 3.036-4.296 3.036-7.33"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#34A853",
    d: "M12.2 21.931c2.753 0 5.064-.886 6.753-2.414l-3.218-2.436c-.862.587-2.017.997-3.536.997a6.13 6.13 0 0 1-5.801-4.141l-.12.01-3.148 2.38-.041.112c1.677 3.256 5.122 5.492 9.11 5.492"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#FBBC05",
    d: "M6.398 13.937a6 6 0 0 1-.34-1.971c0-.687.125-1.351.329-1.971l-.006-.132-3.187-2.42-.105.05a9.8 9.8 0 0 0-1.088 4.473 9.8 9.8 0 0 0 1.088 4.473z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#EB4335",
    d: "M12.2 5.853c1.914 0 3.206.809 3.942 1.484l2.879-2.746C17.253 2.985 14.953 2 12.199 2 8.211 2 4.766 4.237 3.09 7.492l3.297 2.503A6.15 6.15 0 0 1 12.2 5.853"
  }
));
Google24.Size = 24;
Google24.Title = "Google";

export { Google24 as default };
